import React from 'react';
import env from 'env';
import { Redirect } from "react-router-dom";
import { useRouter, SiteLink } from 'components';
import { useGet, usePost } from 'components';
import { Button, ErrorMessage } from 'components';
import { ErrorPopup } from 'components';
import { formatDateTime } from 'lib/utils-core/dateExt'

export function ContactView(props) {
  const { query } = useRouter();
  const get = useGet();

  const contactId = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + `/api/contactAdmin/getContact/${contactId}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;

  return <Contact data={data} contactId={contactId} />
}

function Contact({ data }) {
  return <div>
    <h1>{data.name} {formatDateTime(data.dateSent, 'yyyy-MM-dd HH:mm')}</h1>
    <div style={{ margin: '1rem 0' }}>
      <SiteLink to="/admin/contacts"> &lt; Back to list</SiteLink>
    </div>

    <div className="row">
      <div className="col-md-6">
        <div style={{ padding: '20px', margin: '20px 0', backgroundColor: 'white' }} dangerouslySetInnerHTML={{ __html: data.body }}></div>

        {/* <Fld name="Status" value={data.contactStatus} /> */}
        {data.contactStatus !== 'Processed' &&
          <ChangeStatus id={data.contactId} status="Processed" />}

        {data.contactStatus === 'Processed' &&
          <ChangeStatus id={data.contactId} status="Received" />}
      </div>
    </div>
  </div>

}

// function Fld({ name, value }) {
//   return <div className="row">
//     <div className="col-md-3">{name}:</div>
//     <div className="col-md-9" style={{ whiteSpace: 'pre-line' }}>{value}</div>
//   </div>
// }

function ChangeStatus({ id, status }) {

  const post = usePost();

  function changeStatus(e) {
    post.send(env.apiBase + "/api/contactAdmin/changeStatus", { contactId: id, contactStatus: status });
  }

  if (post.done()) {
    return <Redirect to="/admin/contacts" />
  }

  return <div>

    <Button onClick={changeStatus} status={post.status}> Change to '{status}'</Button>
    <ErrorMessage errors={post.errors} />
  </div>
}